import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to   { opacity: 0; }
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  overflow: hidden;
`;

type AnimState = 'stable' | 'entering' | 'leaving';

export const CarouselImage = styled.div<{ $imageUrl?: string; $animState?: AnimState }>`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background-image: ${({ $imageUrl }) =>
    $imageUrl ? `url("${$imageUrl}")` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'};
  background-size: cover;
  background-position: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent; /* タップ時のデフォルト暗転を無効化 */
  ${({ $animState }) => {
    if ($animState === 'entering') return css`z-index: 1; animation: ${fadeIn} 0.5s ease forwards;`;
    if ($animState === 'leaving') return css`z-index: 2; pointer-events: none; animation: ${fadeOut} 0.5s ease forwards;`;
    return css`z-index: 1;`;
  }}
`;

export const DateOverlay = styled.div`
  position: absolute;
  z-index: 3;
  top: 5px;
  left: 5px;
  background-color: rgba(255, 255, 255, 0.4);
  padding: 4px 8px;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  box-shadow: ${({ theme }) => theme.shadows.sm};
`;

export const ImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 64px;
  opacity: 0.5;
`;
